import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation.ts';
import type { WebItemLocationQueryType } from '@confluence/web-item-location/entry-points/WebItemLocationQuery.ts';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';

import { getGlobalAppsParams } from './getGlobalAppsParams.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export const preloadGlobalApps = async (): Promise<void | {
	data: WebItemLocationQueryType | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> => {
	const { edition, accessStatus } = getPreloaderFnContext();

	const { webItemParams } = getGlobalAppsParams({
		edition,
		accessStatus,
	});

	return preloadWebItemLocation(webItemParams);
};
